import React from 'react';
import {connect} from 'react-redux';
import {ENDPOINT_SSE} from 'common/endpoints';
import Notification from 'app-ui-componentlibrary/dist/go/components/common/Notification';
import EventSource from 'eventsource';
import _ from 'lodash';

export class EventSourceController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
      subscription: null,
      retry: true,
      firstTime: true,
    };
  }

  componentDidUpdate(prevProps) {
    // example: logging in after being logged out due to invalid token
    if (!_.isNil(this.props.token) && prevProps.token !== this.props.token) {
      this.setState({
        retry: true,
      });
    }
  }

  componentWillUnmount() {
    if (!_.isNil(this.state.subscription)) {
      this.state.subscription.close();
    }
  }

  handleError = (e) => {
    if (e && (e.status === 504 || e.status === 500)) {
      this.setState({retry: false}, () =>
        setTimeout(() => this.setState({retry: true}), 10000)
      );
    } else {
      this.clear();
    }
  };

  clear = () => {
    if (!_.isNil(this.state.subscription)) {
      this.state.subscription.close();
    }
    this.setState({
      events: [],
      subscription: null,
      retry: true,
    });
  };

  subscribe() {
    this.setState(
      {
        retry: false,
        firstTime: false,
      },
      this.subscribeHelper
    );
  }

  subscribeHelper = _.debounce(
    () => {
      let subscription = new EventSource(ENDPOINT_SSE + 'subscribe');
      subscription.onmessage = this.setNotification;
      subscription.onerror = this.handleError;
      this.setState((prevState) => {
        if (!_.isNil(this.state.subscription)) {
          this.state.subscription.close();
        }
        return {
          ...prevState,
          subscription,
        };
      });
    },
    3000,
    {maxWait: 1}
  );

  setNotification = (e) => {
    this.setState((prevState) => {
      prevState.events.push(e.data);
      return {...prevState};
    });
  };

  dismissEvent = (index) => {
    let events = this.state.events;
    events.splice(index, 1);
    this.setState({
      events: events,
    });
  };

  renderNotification(message, index) {
    let styleObject = {
      top: 100 + index * 125,
    };
    return (
      <Notification
        header="Notification"
        innerHTML={message}
        cssStyle={styleObject}
        key={index}
        visible={true}
        dismissEvent={() => {
          this.dismissEvent(index);
        }}
      />
    );
  }

  render() {
    const {events, retry, subscription} = this.state;
    const {token} = this.props;

    let hasToken = !_.isNil(token);
    let hasSub = !_.isNil(subscription);
    if (hasToken && retry) {
      this.subscribe();
    } else if (!hasToken && hasSub) {
      this.clear();
    }

    return (
      <React.Fragment>
        {_.map(events, (message, index) => {
          return this.renderNotification(message, index);
        })}
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(EventSourceController);
